// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1avis","unreadBadge":"styles_unreadBadge__1_BRb","modalContent":"styles_modalContent__fQknp","modal":"styles_modal__B-FVq"};